import { render, staticRenderFns } from "./personnel_manager.vue?vue&type=template&id=0a3153bc&scoped=true&"
import script from "./personnel_manager.vue?vue&type=script&lang=js&"
export * from "./personnel_manager.vue?vue&type=script&lang=js&"
import style0 from "./personnel_manager.vue?vue&type=style&index=0&id=0a3153bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3153bc",
  null
  
)

export default component.exports